import VendorIndex from "@/views/vendor/VendorIndex.vue";

const vendor = [
    {
        path: '/vendor',
        name: 'vendor',
        component: VendorIndex
    }
]

export default vendor;